export default function placeCards() {
  return {
    _id: false,
    type: 'droplet.placeCards',
    mediaQueries: [],
    pageCSS: '',
    bounceDroplet: false,
    isShared: false,
    templateRegion: false,
    hideFilters: false,
    customCategories: [],
    customList: false,
    paginate: 24,
    placeholder: 'Search...',
    sortKey: {
      label: 'Name',
      value: 'name',
    },
    map: false,
    sort: 'normal',
    match: 'all',
    filterText: 'Filters',
  };
}



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/place-cards/droplet.schema.js